import { Chip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { useInfiniteHits, useSearchBox } from "react-instantsearch";
import { styled } from "@mui/material/styles";

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "&.Mui-focused": {
    color: theme.palette_custom.lightBlue,
    "&:after": {
      borderBottom: `2px solid ${theme.palette_custom.lightBlue}`,
    },
  },
  "&.Mui-disabled": {
    color: theme.palette_custom.darkBlue,
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    fontSize: theme.fontSize.sm,
  },
  "& .MuiInputBase-input": {
    fontSize: theme.fontSize.sm,
  },
  "&.Mui-disabled, & .Mui-disabled": {
    WebkitTextFillColor: theme.palette_custom.darkBlue,
  },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  color: theme.palette_custom.darkBlue,
  fontSize: theme.fontSize.sm,
  borderRadius: 0,
}));

const SelectAutocomplete = (props) => {
  return (
    <Autocomplete
      // renderTags is similar to the default render tag. It fixes the concole
      // alert regarding the key parameter that is spreaded to the Chip component.
      renderTags={(value, getTagProps, ...props) =>
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={key}
              label={props[0].getOptionLabel(option)}
              {...tagProps}
            />
          );
        })
      }
      {...props}
    />
  );
};

const SelectAutocompleteTextField = ({ variant = "standard", ...props }) => {
  return <StyledTextField {...props} variant="standard" />;
};

const optionEqualsToValueByValue = (option, value) => {
  return value.value && option.value == value.value;
};

const optionEqualsToValueById = (option, value) => {
  return value.id && option.id == value.id;
};

const TypesenseAutocomplete = ({ onInputChange, ...props }) => {
  const { refine } = useSearchBox();
  const { hits, hasMore, refineNext, results } = useInfiniteHits();

  return (
    <SelectAutocomplete
      {...props}
      options={hits || []}
      onInputChange={(e, value) => {
        onInputChange && onInputChange(e, value);
        refine(value);
      }}
      forcePopupIcon
      freeSolo
    />
  );
};

export {
  SelectAutocomplete,
  StyledTextField,
  SelectAutocompleteTextField,
  TypesenseAutocomplete,
  optionEqualsToValueByValue,
  optionEqualsToValueById,
};
